interface InitOpenPayVars {
  apiKey: string;
  id: string;
  isProd: boolean;
}

export const initOpenPay = ({ apiKey, id, isProd }: InitOpenPayVars): void => {
  const OpenPay = window.OpenPay;
  if (!OpenPay) return;

  OpenPay.setApiKey(apiKey);
  OpenPay.setId(id);
  if (!isProd) OpenPay.setSandboxMode(true);
};

export const getDeviceId = (): string | undefined => {
  const OpenPay = window.OpenPay;
  if (!OpenPay) return;

  const deviceId = OpenPay.deviceData.setup();

  return deviceId;
};

export const validateExpiration = (expiration: string): boolean => {
  const [month, year] = expiration.split('/');
  return window?.OpenPay?.card?.validateExpiry(month, year);
};

export const validate = {
  cvv: window?.OpenPay?.card?.validateCVC,
  card: window?.OpenPay?.card?.validateCardNumber,
  expiry: validateExpiration,
};

export const getCardType = (card: string): string => {
  const OpenPay = window.OpenPay;
  if (!OpenPay) return '';

  return OpenPay.card.cardType(card);
};

export default window.OpenPay;
